import genericLogo from '../images/sidebar-company-logo.png'


export const extractImageExtension = fileName => {
    if (fileName) {
        let ext = fileName.split('.').pop();
        if (ext) {
            return ext.toLowerCase();
        }
        return '';
    }
}

export const createImageString = image => {
    if (image && image.fileName && image.encodedLogoValue) {
        return 'data:image/' + extractImageExtension(image.fileName) + ';base64, ' + image.encodedLogoValue;
    } else {
        return genericLogo;
    }
}